import { useEffect, useRef, useState } from "react";
import { LogoutButton } from "../../features/auth";
import Person2RoundedIcon from '@mui/icons-material/Person2Rounded';
import { Link } from "react-router";

export function ProfileOptionsMenu() {
    const [isOpen, setIsOpen] = useState(false);
    const modalRef = useRef<HTMLDivElement>(null);
    const buttonRef = useRef<HTMLDivElement>(null);
    const [modalPosition, setModalPosition] = useState<{ top: number; left: number; }>({
        top: 0,
        left: 0,
    });

    const toggleModal = () => {
        if(buttonRef.current) {
            const rect = buttonRef.current.getBoundingClientRect();
            setModalPosition({
                top: rect.bottom + window.scrollY + 5,
                left: rect.left + window.scrollX - 30,
            });
        }

        setIsOpen(!isOpen);
    }

    const handleClickOutside = (event: MouseEvent) => {
        if(modalRef.current &&
        !modalRef.current.contains(event.target as Node) &&
        buttonRef.current && 
        !buttonRef.current.contains(event.target as Node)) {
            setIsOpen(false);
        }
    }

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        }
    }, []);

    const closeModal = () => {
        setIsOpen(false);
    }

    return (
        <>
        <div 
            ref={buttonRef}
            className="rounded-full bg-gray-400 h-8 w-8 cursor-pointer"
            onClick={toggleModal}>
        </div>
        {isOpen && (
        <div
            className="absolute bg-white shadow-lg border border-gray-300 rounded p-2 z-50 w-40"
            ref={modalRef}
            style={{ top: modalPosition.top, left: modalPosition.left }}>

            <Link 
                to={"/perfil"}
                onClick={closeModal}
                className="no-underline text-black hover:text-black">
                <div 
                    className="flex gap-x-1 cursor-pointer hover:bg-gray-200 w-full rounded-[3px] px-[6px] py-[5px]">
                    <Person2RoundedIcon sx={{ height: 20, width: 20 }}/>
                    <p className="text-sm">Perfil</p>
                </div>
            </Link>

            <div className="w-full">
                <LogoutButton />
            </div>

        </div>
        )}
        </>

    );
}
